export default __webpack_public_path__ + "static/media/480_business04-it-web.f638ae8b.png";